{
  "Poll_Viewer_VoteCount_Modal_Voters_Private_Voter": "Private User",
  "Poll_Viewer_ShowAllOptions_CTA": "Tutte le opzioni",
  "Spoiler_Reveal_Tooltip": "Clicca per scoprire",
  "VerticalEmbed_Event_Error_Subtitle": "Questo evento è stato eliminato. Sostituiscilo con un altro.",
  "Viewer_Toolbar_Twitter_Tooltip": "Twittalo",
  "CollapsibleListPlugin_CollapseButton_AriaLabel": "L'elemento è ridotto",
  "Spoiler_Reveal_Video_CTA": "Mostra video",
  "VerticalEmbed_Pricing_Plan": "Solo pacchetto",
  "Image_Expand_Button_AriaLabel": "Espandi immagine",
  "VerticalEmbed_From_Price": "Da",
  "Poll_Viewer_ShowAllResults_CTA": "Vedi tutti i risultati",
  "Spoiler_Reveal_Image_Placeholder": "Questa immagine contiene uno spoiler",
  "VerticalEmbed_Ribbon": "Offerta",
  "Audio_Plugin_Elapsed_Time_Slider_AriaLabel": "Slider di ricerca",
  "VerticalEmbed_Error_Subtitle": "L'elemento è stato eliminato. Sostituiscilo con un altro.",
  "Poll_Viewer_Multiselect_Footer": "Puoi votare per più di una risposta.",
  "Audio_Plugin_More_Actions_Button_AriaLabel": "Mostra altri controlli audio",
  "VerticalEmbed_Booking_Fetch_Error_Title": "Impossibile caricare il servizio",
  "Fullscreen_Close_Button_AriaLabel": "Chiudi",
  "VerticalEmbed_Event_Fetch_Error_Title": "Impossibile caricare l'evento",
  "UploadFile_Viewer_Loader": "Caricamento di {{fileType}}",
  "Polls_Plugin_User_Avatar_Alt": "Avatar utente",
  "Preview_ReadMore_Label": "Continua a Leggere",
  "Spoiler_Insert_Tooltip": "Spoiler",
  "VerticalEmbed_Product_Fetch_Error_Title": "Impossibile caricare il prodotto",
  "Fullscreen_Shrink_Button_AriaLabel": "Riduci",
  "Audio_Plugin_Volume_Control_Slider_AriaLabel": "Volume",
  "Spoiler_Reveal_Gallery_Placeholder": "Questa galleria contiene uno spoiler",
  "Fullscreen_Expand_Button_AriaLabel": "Espandi",
  "VerticalEmbed_Bookings_Button": "Prenota",
  "Audio_Plugin_Volume_Control_Unmute_AriaLabel": "Riattiva audio",
  "Spoiler_Reveal_Gallery_CTA": "Mostra galleria",
  "Poll_Viewer_ShowLess_CTA": "Mostra Meno",
  "VerticalEmbed_Disabled_Button_Tooltip": "Product page will be available once you publish your site.",
  "Audio_Plugin_Volume_Control_Mute_AriaLabel": "Silenzia",
  "Poll_Viewer_VoteCount_Modal_Voters_Anonymous": "+ {{anonNumber}} anonimo",
  "Poll_Viewer_VoteCount_Modal_Voters_CTA_Follow": "Segui",
  "VerticalEmbed_Products_Button": "Acquista",
  "Poll_Viewer_Toast_Error_ServerDown": "Impossibile connettersi al server. Riprova più tardi.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header": "{{count}} persona ha votato per questa risposta",
  "Poll_Viewer_VoteCount": "{{number}} voti",
  "VerticalEmbed_Events_Button": "Registrati",
  "Spoiler_Reveal_Image_CTA": "Mostra immagine",
  "Poll_Viewer_Toast_Error_Connection": "C'è un problema con internet. Verifica la tua connessione.",
  "Poll_Viewer_Visibility_Owner_Footer": "Solo tu puoi vedere i risultati.",
  "VerticalEmbed_Booking_Error_Title": "Servizio eliminato.",
  "VerticalEmbed_Product_Error_Title": "Prodotto eliminato",
  "VerticalEmbed_Fetch_Error_Subtitle": "Impossibile caricare le informazioni sull'articolo.",
  "Poll_Viewer_VoteCount_Modal_Voters_Header_plural": "{{count}} persone hanno votato per questa risposta",
  "VerticalEmbed_Event_Error_Title": "Evento eliminato.",
  "CollapsibleListPlugin_ExpandButton_AriaLabel": "L'elemento è espanso",
  "Audio_Plugin_Cover_Alt": "Copertina audio",
  "Spoiler_Reveal_Video_Placeholder": "Questo video contiene uno spoiler",
  "VerticalEmbed_Product_Fetch_Error_Subtitle": "C'è stato un problema tecnico. Verifica la connessione e riprova.",
  "VerticalEmbed_Fetch_Error_Title": "Impossibile caricare l'articolo",
  "Poll_Viewer_Option_AriaLabel_Unchecked": "unchecked",
  "VerticalEmbed_Product_Error_Subtitle": "Questo prodotto è stato eliminato. Sostituiscilo con un altro.",
  "VerticalEmbed_Booking_Error_Subtitle": "Questo servizio è stato eliminato. Sostituiscilo con un altro.",
  "Preview_SeeFullPost_Label": "Vedi post intero",
  "UploadFile_Viewer_Download": "Scarica {{fileType}}",
  "VerticalEmbed_Units_Hour": "{{hours}} h",
  "VerticalEmbed_Units_Minute": "{{minutes}} min",
  "VerticalEmbed_Event_Fetch_Error_Subtitle": "C'è stato un problema tecnico. Verifica la connessione e riprova.",
  "VerticalEmbed_Error_Button": "Sostituisci",
  "VerticalEmbed_Error_Title": "Articolo eliminato",
  "VerticalEmbed_Booking_Fetch_Error_Subtitle": "C'è stato un problema tecnico. Verifica la connessione e riprova.",
  "Poll_Viewer_Option_AriaLabel_Checked": "checked"
}
